import { ActionIcon, Group } from '@mantine/core';
import { IconCaretDownFilled, IconCaretUpFilled } from '@tabler/icons-react';
import { ReactNode } from 'react';

interface ToggleGroupProps {
  title: ReactNode;
  opened: boolean;
  toggle: () => void;
}

export function ToggleGroup({ title, toggle, opened }: ToggleGroupProps) {
  return (
    <Group>
      {title}
      <ActionIcon
        size="sm"
        variant="filled"
        aria-label="toggle"
        onClick={toggle}
      >
        {opened ? (
          <IconCaretUpFilled
            style={{ width: '70%', height: '70%' }}
            stroke={1.5}
          />
        ) : (
          <IconCaretDownFilled
            style={{ width: '70%', height: '70%' }}
            stroke={1.5}
          />
        )}
      </ActionIcon>
    </Group>
  );
}
